import { render } from "./manageNavigator.vue?vue&type=template&id=2c2cb406&scoped=true&lang=pug"
import script from "./manageNavigator.vue?vue&type=script&lang=js"
export * from "./manageNavigator.vue?vue&type=script&lang=js"

import "./manageNavigator.vue?vue&type=style&index=0&id=2c2cb406&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2cb406"]])

export default __exports__